import "./../components/Navi/_naviMain.js";
import "./../components/Navi/_naviMobile.js";
import "./../components/Subtabs/_subtabs.js";
import "./../components/Header/_header.js";
import "./../components/HeroSlider/_heroSlider.js";
import "./../components/Lightbox/_lightbox.js";

class MarkLoaded {
	constructor(target) {
        this.targetList = document.querySelectorAll(target);
    }

    bindEvent() {
        window.addEventListener(
            'load', () => {
                this.targetList.forEach(
                    target => {
						target.classList.add('js-loaded');
                    }
                );
            }
        );
    }

}

let onLoad = new MarkLoaded(".js-loaded__target");
onLoad.bindEvent();

// import "./../components/Accordion/_accordion.js";
// import "./../components/Lightbox/_lightbox.js";
// import "./../components/Slider/_slider.js";